/* Side-Quest Saturdays booking form — LoCo */
(function () {
  const form = document.querySelector('[data-sq-booking]');
  if (!form) return;

  const variantId = Number(form.dataset.variantId);
  const price = Number(form.dataset.price); // cents
  const max = Math.max(1, Number(form.dataset.max) || 1);
  const closeAt = Number(form.dataset.close) * 1000;
  const hotOnly = (form.dataset.hotOnly || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);

  const list = form.querySelector('[data-sq-attendees]');
  const tpl = form.querySelector('[data-sq-attendee-template]');
  const countEl = form.querySelector('[data-sq-count]');
  const minus = form.querySelector('[data-sq-minus]');
  const plus = form.querySelector('[data-sq-plus]');
  const totalEl = form.querySelector('[data-sq-total]');
  const errorEl = form.querySelector('[data-sq-error]');
  const submit = form.querySelector('[data-sq-submit]');
  let count = 1;
  let uid = 0;

  const peso = (cents) => '₱' + (cents / 100).toLocaleString('en-PH', { maximumFractionDigits: 2 });

  function syncHot(fs) {
    const drink = fs.querySelector('select[data-f="drink"]').value.toLowerCase();
    const iced = fs.querySelector('input[value="Iced"]');
    const hot = fs.querySelector('input[value="Hot"]');
    const forceHot = hotOnly.includes(drink);
    iced.disabled = forceHot;
    if (forceHot) hot.checked = true;
  }

  function addAttendee() {
    const node = tpl.content.firstElementChild.cloneNode(true);
    uid += 1;
    node.querySelectorAll('input, select').forEach((el) => {
      el.dataset.f = el.name;
      if (el.type === 'radio') {
        el.name = el.name + '-' + uid;
      } else {
        const id = 'sq-' + el.name + '-' + uid;
        el.id = id;
        const label = el.closest('.sq-field').querySelector('label');
        if (label) label.htmlFor = id;
      }
    });
    node.querySelector('select[data-f="drink"]').addEventListener('change', () => syncHot(node));
    list.appendChild(node);
  }

  function render() {
    while (list.children.length < count) addAttendee();
    while (list.children.length > count) list.lastElementChild.remove();
    [...list.children].forEach((fs, i) => {
      fs.querySelector('[data-sq-attendee-title]').textContent =
        count === 1 ? 'Your seat' : 'Seat ' + (i + 1) + (i === 0 ? ' (you)' : '');
    });
    countEl.textContent = count;
    minus.disabled = count <= 1;
    plus.disabled = count >= max;
    totalEl.textContent = peso(price * count);
  }

  minus.addEventListener('click', () => { if (count > 1) { count -= 1; render(); } });
  plus.addEventListener('click', () => { if (count < max) { count += 1; render(); } });
  render();

  function fail(msg, el) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    if (el) { const f = el.closest('.sq-field'); if (f) f.classList.add('sq-field--invalid'); el.focus(); }
    submit.disabled = false;
  }
  form.addEventListener('input', (e) => { const f = e.target.closest('.sq-field'); if (f) f.classList.remove('sq-field--invalid'); });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.hidden = true;
    submit.disabled = true;

    if (Date.now() >= closeAt) return fail('Booking for this Quest has closed.');

    const attendees = [];
    for (const fs of list.children) {
      const name = fs.querySelector('[data-f="name"]');
      const drink = fs.querySelector('[data-f="drink"]');
      const food = fs.querySelector('[data-f="food"]');
      const temp = fs.querySelector('input[type="radio"]:checked');
      if (!name.value.trim()) return fail('Please enter a name for every seat.', name);
      if (!drink.value) return fail('Please choose a drink for every seat.', drink);
      if (!food.value) return fail('Please choose a food item for every seat.', food);
      attendees.push({ name: name.value.trim(), drink: drink.value, temp: temp ? temp.value : 'Iced', food: food.value });
    }
    const mobile = form.querySelector('[name="mobile"]');
    const handle = form.querySelector('[name="handle"]');
    const heard = form.querySelector('[name="heard"]');
    const first = form.querySelector('[name="first_time"]:checked');
    const photo = form.querySelector('[name="photo"]:checked');
    const policy = form.querySelector('[name="policy"]');
    if (mobile.value.replace(/\D/g, '').length < 10) return fail('Please enter a valid mobile number.', mobile);
    if (!handle.value.trim()) return fail('Please enter your IG or FB handle so we can reach you.', handle);
    if (!first) return fail('Please tell us if this is your first time at LoCo.');
    if (!heard.value) return fail('Please tell us how you heard about Side-Quests.', heard);
    if (!policy.checked) return fail('Please confirm the refund and transfer policy.', policy);

    const items = attendees.map((a, i) => ({
      id: variantId,
      quantity: 1,
      properties: {
        'Attendee': a.name,
        'Drink': a.drink + ' (' + a.temp + ')',
        'Food': a.food,
        'Booked by': attendees[0].name,
        'Mobile': mobile.value.trim(),
        'IG/FB': handle.value.trim(),
        'First time at LoCo': i === 0 ? first.value : '—',
        'Heard about us': heard.value,
        'Photo consent': photo ? photo.value : 'OK to appear in LoCo posts',
        'Policy': 'Agreed: non-refundable, transferable until 12 noon on the day',
      },
    }));

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // Remove earlier attempts for this Quest so seats aren't doubled.
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const stale = {};
      cart.items.filter((it) => it.variant_id === variantId).forEach((it) => { stale[it.key] = 0; });
      if (Object.keys(stale).length) {
        await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: stale }) });
      }
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        const msg = (data && (data.description || data.message)) || '';
        if (/sold out|quantity|stock|available/i.test(msg)) {
          return fail('Sorry, there aren\'t enough seats left for ' + count + '. Try fewer seats or refresh the page.');
        }
        return fail('Something went wrong adding your seats. Please try again.' + (msg ? ' (' + msg + ')' : ''));
      }
      window.location.href = root + 'checkout';
    } catch (err) {
      fail('We couldn\'t reach the booking system. Check your connection and try again.');
    }
  });
})();
